@if (lesson) {
  <section class="col-10 mx-auto text-center">
    <header>
      <h1>{{lesson.title}}</h1>
    </header>
    <div class="intro-video">
      <iframe [src]="vimeoUrl | safeUrl" width="770" height="434" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </div>
    <p class="lead">{{lesson.description}}</p>
    <a class="btn btn-primary btn-lg" [routerLink]="['../strategy-topic']">Get Started</a>
  </section>
} @else {
  <app-spinner></app-spinner>
}
